export default {
	header: 'Garanti',
	overLimitGuarantors: '(více garantů zobrazíte pomocí tlačítka editovat)',
	moreThenOne: 'Garanti',
	moreThenFive: 'Garantů',
	edit: 'Editovat',
	editGuarantorModalTitle: 'Editace garanta regionu',
	add: 'Přidat',
	none: 'Žádný garant',
	regionCp: 'Kraj: {{name}}',
	regionGli: 'Kraj: {{name}}',
	addAllRegions: 'Zařadit všechny regiony',
	removeAllRegions: 'Vyřadit všechny regiony',
	nameAndSurname: 'Příjmení a jméno',
	sellerIn: 'Získatelské číslo',
	login: 'Login',
	profession: 'Profese',
	result: 'Výsledek vyhledávání',
	byOrganizeStructure: 'Dle organizační struktury',
	outOrganizeStructure: 'Mimo organizační strukturu',
	requiredFieldsError: 'Alespoň jedno ze zvýrazněných kritérií musí být vyplněno.',
	firstName: 'Jméno',
	surname: 'Příjmení',
};
